class ReportIssueForm extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('.report-issue-form__submit');
    this.status = this.querySelector('.report-issue-form__status');
    if (!this.btn) return;
    this.btn.addEventListener('click', () => this.submit());
  }
  show(msg, ok) {
    if (!this.status) return;
    this.status.hidden = false;
    this.status.textContent = msg;
    this.status.classList.toggle('error', !ok);
  }
  async submit() {
    if (this.loading) return;
    this.loading = true;
    try {
      const categoryEl = this.querySelector('#ReportIssueCategory');
      const category = categoryEl ? categoryEl.value : '';
      if (!category) {
        this.show(this.dataset.errEmpty || 'Please choose a category.', false);
        this.loading = false;
        return;
      }
      const noteEl = this.querySelector('#ReportIssueNote');
      const emailEl = this.querySelector('#ReportIssueEmail');
      const email = (emailEl ? emailEl.value : '').slice(0, 320); // note/email length caps — mirror server-side limits
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.show(this.dataset.msgEmailInvalid || 'Please enter a valid email, or leave it blank.', false);
        this.btn.disabled = false;
        this.loading = false;
        return;
      }
      const payload = {
        product_id: this.dataset.productId,
        product_handle: this.dataset.productHandle,
        product_title: this.dataset.productTitle,
        category,
        note: (noteEl ? noteEl.value : '').slice(0, 2000), // note/email length caps — mirror server-side limits
        email,
        url: location.href,
      };
      this.btn.disabled = true;
      this.show(this.dataset.msgPending || 'Sending…', true);
      const r = await fetch(this.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!r.ok) throw new Error(r.status);
      this.show(this.dataset.msgSuccess || 'Thanks — report received.', true);
      this.btn.hidden = true;
    } catch (e) {
      this.btn.disabled = false;
      this.loading = false;
      this.show(this.dataset.msgError || 'Something went wrong. Please try again.', false);
    }
  }
}
if (!customElements.get('report-issue-form')) {
  customElements.define('report-issue-form', ReportIssueForm);
}
